class BaoBlogArticleGrid extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onLoadMoreClick = this.onLoadMoreClick.bind(this)
    this.listeners.add(
      this.els['load-more'].element,
      'click',
      this.onLoadMoreClick,
    )
  }

  onLoadMoreClick (e) {
    const anchor = e.target.closest('a[href]')
    if (!anchor) return
    e.preventDefault()
    this.loadMore(anchor.href)
  }

  async loadMore (url) {
    const anchor = this.els['load-more'].element?.querySelector('a[href]')

    if (anchor) {
      anchor.setAttribute('aria-busy', 'true')
      anchor.style.opacity = '0.6'
      anchor.style.pointerEvents = 'none'
    }

    try {
      const sectionId = this.dataset.blogArticleGrid
      const html = await window.BAO.sectionRenderer.fetchSingle(sectionId, url)

      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      // Append new article items to the grid
      const newItems = doc.querySelectorAll(
        '[data-bao-blog-article-grid-el="grid"] > *',
      )
      newItems.forEach((item) => this.els.grid.element.appendChild(item))

      // Replace load-more block with updated one (new URL or empty if last page)
      const newLoadMore = doc.querySelector(
        '[data-bao-blog-article-grid-el="load-more"]',
      )
      if (newLoadMore) {
        this.els['load-more'].element.innerHTML = newLoadMore.innerHTML
      }
    } catch (err) {
      if (anchor) {
        anchor.removeAttribute('aria-busy')
        anchor.style.opacity = ''
        anchor.style.pointerEvents = ''
      }
    }
  }
}

if (!customElements.get('bao-blog-article-grid')) {
  customElements.define('bao-blog-article-grid', BaoBlogArticleGrid)
}
